<template>
  <div class="sect-section">
    <div class="container">
      <div class="row">
        <div class="col-12">
          <h1 class="sect-title">{{ sectData.name }}</h1>
          <p class="lead text-center mb-5" style="color: #e9ecef;">
            {{ sectData.description }}
          </p>
        </div>
      </div>

      <div class="row">
        <div
          class="col-md-4 mb-4"
          v-for="clan in sectData.clans"
          :key="clan.name"
        >
          <div class="card clan-card h-100" @click="selectClan(clan)">
            <div class="card-body text-center">
              <div class="clan-symbol-container">
                <img
                  v-if="isImageSymbol(clan.symbol)"
                  :src="getImageUrl(clan.symbol)"
                  :alt="`Símbolo do clã ${clan.name} em Vampiro: A Máscara`"
                  class="clan-symbol-image"
                  loading="lazy"
                />
                <span v-else class="clan-symbol-emoji">{{ clan.symbol }}</span>
              </div>
              <h5 class="card-title mt-3">{{ clan.name }}</h5>
              <p class="card-text">{{ clan.nickname }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="row mt-4">
        <div class="col-12 text-center">
          <button class="btn btn-vampire" @click="goBack">
            <i class="bi bi-arrow-left me-2"></i>
            Voltar ao Início
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { clansData } from '../data/clans.js'

export default {
  name: 'SectView',
  props: {
    sect: {
      type: String,
      required: true
    }
  },
  computed: {
    sectData() {
      return clansData[this.sect] || { name: 'Seita Desconhecida', description: '', clans: [] }
    }
  },
  methods: {

    isImageSymbol(symbol) {
      if (typeof symbol !== 'string') {
        return false
      }

      const normalized = symbol.toLowerCase()
      const imageExtensions = ['.png', '.jpg', '.jpeg', '.gif', '.svg', '.webp']

      return (
        normalized.startsWith('http://') ||
        normalized.startsWith('https://') ||
        normalized.startsWith('data:') ||
        normalized.startsWith('/') ||
        imageExtensions.some(ext => normalized.includes(ext))
      )
    },
    getImageUrl(symbol) {
      if (!symbol || typeof symbol !== 'string') {
        return ''
      }

      if (
        symbol.startsWith('http://') ||
        symbol.startsWith('https://') ||
        symbol.startsWith('data:') ||
        symbol.startsWith('/')
      ) {
        return symbol
      }

      return new URL(`../assets/${symbol}`, import.meta.url).href
    },
    selectClan(clan) {
      this.$emit('show-clan-modal', clan)
    },
    goBack() {
      this.$emit('go-back')
    }
  }
}
</script>

<style scoped>
.clan-symbol-container {
  height: 80px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.clan-symbol-image {
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 10px;
}

.clan-symbol-emoji {
  font-size: 4rem;
  filter: drop-shadow(2px 2px 4px rgba(0, 0, 0, 0.8));
}

.card-subtitle {
  font-style: italic;
}

.clan-card {
  transition: all 0.3s ease;
  cursor: pointer;
}

.clan-card:hover {
  transform: translateY(-8px);
  box-shadow: 0 12px 24px var(--vampire-shadow);
}
</style>
